import React from 'react';
import OnBoardingScreen from './containers/Onboarding';
import RulesScreen from './containers/Rules';
import ProgressScreen from './containers/Progress';
import Dashboard from './containers/Dashboard';
import SeeAllpolicy from './containers/SeeAllPolicy';
import Support from './containers/Support';
import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import axagoalSaga from './sagas/';
import myPrivilegesSaga from './sagas/myPrivilegesSaga';
import dashboardSaga from './sagas/dashboardSaga';
import myPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import AxaGoalMyPrivilegesCardView from './containers/MyPrivilegesCardView';
import AxaGoalMyPrivilegesDetailsView from './containers/MyPrivilegesDetailsView';
import Record from './containers/Record';

myPrivilegesCardViewRegistry.register(
  config.id,
  AxaGoalMyPrivilegesCardView,
  AxaGoalMyPrivilegesDetailsView,
  false,
  config.myPrivigesReducerSubName,
);
myPrivilegesCardViewRegistry.register(
  config.disabledId,
  AxaGoalMyPrivilegesCardView,
  AxaGoalMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);

export default {
  config,
  routes: {
    '/summary/:id/:entityCode': {
      exact: true,
      container: OnBoardingScreen,
    },
    '/summary/:id/:entityCode/:membershipYear': {
      exact: true,
      container: OnBoardingScreen,
    },
    '/summary-:ruleType/:id/:entityCode': {
      exact: true,
      container: OnBoardingScreen,
    },
    '/rules/wgp': {
      exact: true,
      container: () => React.createElement(RulesScreen, { ruleType: 'WGP' }),
    },
    '/rules/sh': {
      exact: true,
      container: () => React.createElement(RulesScreen, { ruleType: 'SH' }),
    },
    '/rules/both': {
      exact: true,
      container: () => React.createElement(RulesScreen, { ruleType: 'BOTH' }),
    },
    '/rules/': {
      exact: true,
      container: RulesScreen,
    },
    '/membership/:id/:entityCode': {
      exact: true,
      container: ProgressScreen,
    },
    '/recode/:month/:achieveDays/:entityCode/:ruleType': {
      exact: true,
      container: Record,
    },
    '/recode/:month/:achieveDays': {
      exact: true,
      container: Record,
    },
    '/dashboard': {
      exact: true,
      container: Dashboard,
    },
    '/seeAllPolicy': {
      exact: true,
      container: SeeAllpolicy,
    },
    '/support-WGP/:entityCode': {
      exact: true,
      container: () =>
        React.createElement(Support, { type: 'axa-goal', ruleType: 'WGP' }),
    },
    '/support-SH/:entityCode': {
      exact: true,
      container: () =>
        React.createElement(Support, { type: 'axa-goal', ruleType: 'SH' }),
    },
    '/support/:entityCode': {
      exact: true,
      container: () => React.createElement(Support, { type: 'axa-goal' }),
    },
    '/support': {
      exact: true,
      container: () => React.createElement(Support, { type: 'axa-goal' }),
    },
  },
  sagas: [axagoalSaga, myPrivilegesSaga, dashboardSaga],
} as ModuleConfig;
